import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { BusinessIntelligenceRepresentationData } from './business-intelligence-representation-data.interface';

export const BUSINESS_INTELLIGENCE_REPRESENTATION_DATA = new InjectionToken<Observable<BusinessIntelligenceRepresentationData>>(
    'BUSINESS_INTELLIGENCE_REPRESENTATION_DATA'
);
